import {UIComponent} from "@/engine/UI/UIComponent.js";
import {UITemplates} from "@/engine/UITemplates.js";
import {UIProperties} from "@/engine/UI/UIProperties.js";
import {elog} from "@/engine/helpers/logging.js";
import {AMUtil} from "@/engine/leaflet/antimeridianUtils.js";

/**
 * Shows UI to export leaflet layer as geoJson
 * options should contain 'layer' property, that can be a single layer object or array of layer objects
 */
export class UICDownloadGeoJson extends UIComponent {
    constructor(options) {
        super(options, null);
        this.id = 'geoJsonExport'
        this.title = 'Download shapes as geoJson'
        this.mainActionName = 'DOWNLOAD'
        this.cancelActionName = 'CANCEL'
        this.formatted = true
        this.styles = false
//        this.className = ''
//        this.contentDataBindPrefix = ''
        this.UIP = new UIProperties(
            UITemplates.getContent("downloadGeoJson",
                {
                    description: 'Selected shapes will be saved as a file in <b>geoJson</b> format.'
                }),
            {
                propertiesFactory: async function (prop) {
                    prop.formatted = this.formatted;
                    prop.styles = this.styles;
                }.bind(this),
                togglersCallbacks: {
                    "styles" : function (val, fail) {
                        this.styles = val;
                    }.bind(this),
                    "formatted": function (val, fail) {
                        this.formatted = val;
                    }.bind(this)
                }
            },
        )
        this.view = this.UIP
    }

    validateBeforeOpen() {
        return this.layer && (Array.isArray(this.layer) || (typeof this.layer === "object"))
    }

    onMainAction() {
        if (!this.layer)
            return false

        let layers;
        let layerGroup = L.geoJson()

        if (Array.isArray(this.layer)) {
            layers = this.layer
        } else {
            layers = [this.layer]
        }

        let fixedLayers = []
        for (let l of layers) {
            // correct layer coords back to CRS bounds if needed (dateline issue)
            if (typeof AMUtil !== 'undefined') {
                if (AMUtil.fixLayer(l, true) !== 0 ) {
                    fixedLayers.push(l)
                }
            }

            layerGroup.addLayer(l)
        }

        // creates JSON
        let json = layerGroup.toGeoJSON()

        // performs back correction if it was done earlier
        for (let l of fixedLayers) {
            AMUtil.fixLayer(l)
        }

        layerGroup.clearLayers()

        let filename = 'geom.geojson';
        if (!json.features) {
            if (typeof elog === "function")
                elog("ERROR", "something got wrong with geoJson export, need to investigate")
        } else {
            //we need to create copy of feature properties as it is an original properties of layer object and we can't modify this
            for (let i in json.features) {
                json.features[i] = Object.assign({}, json.features[i])
                if (json.features[i].properties) {
                    json.features[i].properties = Object.assign({}, json.features[i].properties)
                    let p = json.features[i].properties
                    // remove options if needed
                    if (!this.styles)
                        delete p.options
                    // we store the feature name in a descr field, set them to name
                    if (p.descr)
                        p.name = p.descr
                        delete p.descr
                }
            }
        }

        this.downloadLink = document.createElement("a")
        Object.assign(this.downloadLink.style, {"display": "none"});
        Object.assign(this.downloadLink, {"download": filename});
        let jsonString
        if (this.formatted) {
            jsonString = JSON.stringify(json, null, 4)
        } else {
            jsonString = JSON.stringify(json)
        }

        let blob = new Blob([jsonString], {type: "application/json"});
        this.downloadLink.href = URL.createObjectURL(blob)
        this.downloadLink.click()
        return true
    }

    onCancelAction() {
        return true
    }

}
